/**
 * CATALOGO UNICO: TRAER LA PLANTILLA A MIS ITEMS (MADERINCO-CATALOGO-UNICO-T1; nexo-api 577, A #31112).
 *
 *   POST /presupuestos/plantilla/casar?confirmar=true          -> CasarPlantillaDto
 *   POST /presupuestos/plantilla/casar/confirmar {items:[...]} -> ConfirmarCasadoDto  (1 a 1000 pares itemId/productoId)
 *
 * Un item cuyo nombre ya lo tiene un producto que creo una persona NO se casa ni se duplica: vuelve en porConfirmar con
 * el producto sugerido, y una persona lo confirma (o lo deja). El panel no casa por nombre por su cuenta.
 *
 * @module application/presupuestos/catalogoUnico
 */

export const MAX_CONFIRMAR = 1000;

const num = (o, a, b) => Number(o?.[a] ?? o?.[b] ?? 0) || 0;
const lista = (o, a, b) => (Array.isArray(o?.[a]) ? o[a] : Array.isArray(o?.[b]) ? o[b] : []);

/** CasarPlantillaDto en camel o Pascal. */
export function leerCasarPlantilla(data) {
  const d = data || {};
  return {
    itemsRevisados: num(d, 'itemsRevisados', 'ItemsRevisados'),
    yaCasados: num(d, 'yaCasados', 'YaCasados'),
    productosCreados: num(d, 'productosCreados', 'ProductosCreados'),
    variantesReusadas: num(d, 'variantesReusadas', 'VariantesReusadas'),
    ubicacionesNuevas: num(d, 'ubicacionesNuevas', 'UbicacionesNuevas'),
    porConfirmar: lista(d, 'porConfirmar', 'PorConfirmar').map((p) => ({
      itemId: String(p.itemId ?? p.ItemId ?? ''),
      descripcion: String(p.descripcion ?? p.Descripcion ?? ''),
      productoSugeridoId: String(p.productoSugeridoId ?? p.ProductoSugeridoId ?? '')
    })).filter((p) => p.itemId && p.productoSugeridoId),
    errores: lista(d, 'errores', 'Errores').map(String)
  };
}

/** ConfirmarCasadoDto en camel o Pascal. */
export function leerConfirmar(data) {
  const d = data || {};
  return {
    pedidos: num(d, 'pedidos', 'Pedidos'),
    confirmados: num(d, 'confirmados', 'Confirmados'),
    yaEstaban: num(d, 'yaEstaban', 'YaEstaban'),
    ubicacionesNuevas: num(d, 'ubicacionesNuevas', 'UbicacionesNuevas'),
    errores: lista(d, 'errores', 'Errores').map(String)
  };
}

/** Lo que paso al traer la plantilla, en frases (cero cuenta como cero, no se esconde). */
export function frasesDelCasado(r) {
  const f = [
    `Revisamos ${r.itemsRevisados} items de tu plantilla.`,
    `${r.productosCreados} productos nuevos en Mis items y ${r.variantesReusadas} que ya existían se reusaron.`,
    `${r.yaCasados} ya estaban unidos a un producto.`
  ];
  if (r.porConfirmar.length) f.push(`${r.porConfirmar.length} se parecen a un producto que tú creaste: confirma abajo si son el mismo.`);
  if (r.errores.length) f.push(`${r.errores.length} no se pudieron traer.`);
  return f;
}

/** Pares para confirmar: solo los marcados, con el producto sugerido, en tandas de hasta 1000. */
export function tandasParaConfirmar(porConfirmar, marcados) {
  const pares = (porConfirmar || [])
    .filter((p) => marcados.has(p.itemId))
    .map((p) => ({ itemId: p.itemId, productoId: p.productoSugeridoId }));
  const tandas = [];
  for (let i = 0; i < pares.length; i += MAX_CONFIRMAR) tandas.push(pares.slice(i, i + MAX_CONFIRMAR));
  return tandas;
}

/** Suma de varias tandas confirmadas. */
export function sumarConfirmados(resultados) {
  return resultados.reduce((a, r) => ({
    pedidos: a.pedidos + r.pedidos, confirmados: a.confirmados + r.confirmados, yaEstaban: a.yaEstaban + r.yaEstaban,
    ubicacionesNuevas: a.ubicacionesNuevas + r.ubicacionesNuevas, errores: a.errores.concat(r.errores)
  }), { pedidos: 0, confirmados: 0, yaEstaban: 0, ubicacionesNuevas: 0, errores: [] });
}
